import 'magnific-popup';

const handleModal = () => {
	$('.js-modal').magnificPopup({
		type: 'inline',
		preloader: false,
		modal: true
	});

	$(document).on('click', '.js-modal-close', function(event) {
		$.magnificPopup.close();

		event.preventDefault();
	});
}

handleModal();
